import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-grafico-torta',
  templateUrl: './grafico-torta.component.html',
  styleUrls: ['./grafico-torta.component.scss']
})
export class GraficoTortaComponent implements OnInit {
  
  @Input() data = {};
  @ViewChild('canvas', {static: false}) canvas: any;

  public context: CanvasRenderingContext2D;

  chart: any
  labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']
  dataG = [65, 59, 80, 81, 56, 55, 40]
  coloR = []

  constructor() {
  }

  ngOnInit(): void {
    this.context = this.canvas.nativeElement.getContext('2d');
    this.chart = new Chart(this.context, {
      type: 'pie',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          data: [65, 59, 80, 81, 56, 55, 40],
          backgroundColor: 'rgba(108, 77, 60, 0.2)',
          borderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1
        }]
      }
    });
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  async ngOnChanges(changes: SimpleChanges) {
    setTimeout(async ()=>{
      this.chart.data.labels = changes.data.currentValue.data.map( item => item.column1)
      this.chart.data.datasets[0].data = changes.data.currentValue.data.map( item => item.column2)
      for (var i in changes.data.currentValue.data) {
        this.coloR.push(this.dynamicColors());
      }
      this.chart.data.datasets[0].backgroundColor = this.coloR
      this.chart.update();
    },500)
  }

}
